import { render, staticRenderFns } from "./year_bonus.vue?vue&type=template&id=a643ffa4"
import script from "./year_bonus.vue?vue&type=script&lang=js"
export * from "./year_bonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports